import { useCallback } from "react";
import { CurrentWorkspaceManager } from "../useCurrentWorkspace";
import useTodo_Local from "./useTodo_Local";
import useTodoList_Local from "./useTodoList_Local";
import useWorkspace_Local from "./useWorkspace_Local";

export const useStorage_Local = (currentWorkspaceManager: CurrentWorkspaceManager) => {
    const { currentWorkspaceId } = currentWorkspaceManager;
    const { refresh: refreshWorkspace, ...workspaceManager } = useWorkspace_Local();
    const { refresh: refreshTodoList, ...todoListManager } = useTodoList_Local(currentWorkspaceId, refreshWorkspace);
    const { refresh: refreshTodo, ...todoManager } = useTodo_Local(currentWorkspaceId, refreshTodoList);

    const refreshAll = useCallback(async () => {
        await refreshWorkspace();
        await refreshTodoList();
        await refreshTodo();
    }, [refreshWorkspace, refreshTodoList, refreshTodo]);

    return {
        refresh: refreshAll,
        refreshWorkspace: refreshWorkspace,
        refreshTodoList: refreshTodoList,
        refreshTodo: refreshTodo,

        //Workspace
        workspaces: workspaceManager.workspaces,
        workspaceMap: workspaceManager.workspaceMap,
        createWorkspace: workspaceManager.createWorkspace,
        deleteWorkspace: workspaceManager.deleteWorkspace,
        updateWorkspace: workspaceManager.updateWorkspace,

        //TodoList
        todoLists: todoListManager.todoLists,
        createTodoList: todoListManager.createTodoList,
        deleteTodoList: todoListManager.deleteTodoList,
        reorderList: todoListManager.reorderList,
        updateListTitle: todoListManager.updateListTitle,

        //Todo
        todos: todoManager.todos,
        todosMap: todoManager.todosMap,
        createTodo: todoManager.createTodo,
        createTodoByTodoData: todoManager.createTodoByTodoData,
        updateTodo: todoManager.updateTodo,
        deleteTodo: todoManager.deleteTodo,
        toggleTodo: todoManager.toggleTodo,
        moveTodoToList: todoManager.moveTodoToList,
    }
}

export default useStorage_Local;